exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".program[data-v-6b619497]{color:#45d375;text-transform:uppercase;font-weight:700;border:none;background-color:transparent;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding-bottom:1px;cursor:pointer}.program:hover .stroke[data-v-6b619497]{stroke:#eb028c}.program:hover .fill[data-v-6b619497]{fill:#eb028c}.program__icon[data-v-6b619497]{margin:0 5px 1px 0}.fill[data-v-6b619497],.stroke[data-v-6b619497]{transition:all .2s ease-out}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6b619497","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/event/card/newProgramButton/NewProgramButton.vue
// module id = ade93e69a7dcfa77acfb
// module chunks = 5